export const GETTERS_LIST_ALL_REQUESTS = "GETTERS_LIST_ALL_REQUESTS";
export const GETTERS_LIST_CHANGE_LOG = "GETTERS_LIST_CHANGE_LOG";
export const GETTERS_LIST_BLOCKED_DOMAINS = "GETTERS_LIST_BLOCKED_DOMAINS";
export const GETTERS_BLOCKED_DOMAIN = "GETTERS_BLOCKED_DOMAIN";
export const ACTION_GET_ALL_REQUESTS = "ACTION_GET_ALL_REQUESTS";
export const ACTION_GET_CHANGE_LOG = "ACTION_GET_CHANGE_LOG";
export const ACTION_GET_LIST_BLOCKED_DOMAINS =
  "ACTION_GET_LIST_BLOCKED_DOMAINS";
export const ACTION_GET_LIST_USE_POLICY = "ACTION_GET_LIST_USE_POLICY";
export const ACTION_GET_ACTIVE_USE_POLICY = "ACTION_GET_ACTIVE_USE_POLICY";
export const ACTION_POST_ADD_BLOCKED_DOMAIN = "ACTION_POST_ADD_BLOCKED_DOMAIN";
export const ACTION_POST_REQUEST = "ACTION_POST_REQUEST";
export const ACTION_RESEND_INVITATION_EMAIL = "ACTION_RESEND_INVITATION_EMAIL";
export const ACTION_POST_USE_POLICY = "ACTION_POST_USE_POLICY";
export const ACTION_DELETE_BLOCKED_DOMAIN = "ACTION_DELETE_BLOCKED_DOMAIN";
export const ACTION_UPDATE_REQUEST = "ACTION_UPDATE_REQUEST";
export const ACTION_POST_APPROVE_REQUEST = "ACTION_POST_APPROVE_REQUEST";
export const GETTERS_REQUEST = "GETTERS_REQUEST";
export const ACTION_GET_REQUEST = "ACTION_GET_REQUEST";
export const MUTATION_SET_REQUEST = "MUTATION_SET_REQUEST";
export const MUTATION_SET_ALL_REQUESTS = "MUTATION_SET_ALL_REQUESTS";
export const MUTATION_SET_CHANGE_LOG = "MUTATION_SET_CHANGE_LOG";
export const MUTATION_SET_LIST_BLOCKED_DOMAINS =
  "MUTATION_SET_LIST_BLOCKED_DOMAINS";
export const MUTATION_SET_LIST_USE_POLICY = "MUTATION_SET_LIST_USE_POLICY";
export const MUTATION_SET_ACTIVE_USE_POLICY = "MUTATION_SET_ACTIVE_USE_POLICY";
export const MUTATION_SET_SINGLE_REQUEST = "MUTATION_SET_SINGLE_REQUEST";
export const MUTATION_SET_BLOCKED_DOMAIN = "MUTATION_SET_BLOCKED_DOMAIN";
export const GETTERS_CLIENTS_ADMIN_LIST = "GETTERS_CLIENTS_ADMIN_LIST";
export const GETTERS_CLIENT_ADMIN_DETAILS = "GETTERS_USER_DETAILS";
export const GETTERS_SINGLE_REQUESTS = "GETTERS_SINGLE_REQUESTS";
export const GETTERS_LIST_USE_POLICY = "GETTERS_LIST_USE_POLICY";
export const GETTERS_ACTIVE_USE_POLICY = "GETTERS_ACTIVE_USE_POLICY";
export const ACTION_GET_LIST_CLIENT_PANEL = "ACTION_GET_LIST_CLIENT_PANEL";
export const ACTION_FILTER_LIST_USER = "ACTION_FILTER_LIST_USER";
export const ACTION_GET_CLIENT_ADMIN_DETAIL = "ACTION_GET_CLIENT_ADMIN_DETAIL";
export const MUTATION_SET_FILTER_LIST_USER = "MUTATION_SET_FILTER_LIST_USER";
export const MUTATION_SET_LIST_CLIENT_PANEL = "MUTATION_SET_LIST_CLIENT_PANEL";
export const MUTATION_SET_CLIENT_ADMIN_DETAILS =
  "MUTATION_SET_CLIENT_ADMIN_DETAILS";
export const GETTERS_EDIT_USER = "GETTERS_EDIT_USER";
export const MUTATION_EDIT_USER = "GETTERS_EDIT_USER";

export const DEFAULT_LIST = {
  data: [],
  meta: {
    pagination: {
      current_page: 1,
      total: 0,
      per_page: 5
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user-provisioning/constants.js